import { FC, useState } from 'react';

import Modal, { ModalProps } from 'antd/lib/modal/Modal';
import SubmitButton from 'components/buttons/SubmitButton/SubmitButton';
import BenefitCarrier from 'model/BenefitCarrier';
import closeIcon from 'images/icon-close.svg';
import { downloadPDLFile } from 'modules/benefitsWellness/slices/medicalSlice';
import { useAppDispatch } from 'hooks/redux';
import styles from './prescriptionDrugListModal.module.less';

interface PrescriptionDrugListModalProps extends ModalProps {
  visible: boolean;
  carrier: BenefitCarrier;
  planName: string;
  networkName: string;
}

const PrescriptionDrugListModal: FC<PrescriptionDrugListModalProps> = ({
  onCancel,
  visible,
  carrier,
}: PrescriptionDrugListModalProps) => {
  const { logoUrl, prescriptionDrugListUrl, prescriptionDrugList } =
    (carrier as any) || {};
  const prescriptionDrugListFile = (carrier as any)?.prescriptionDrugListFile;
  const hasPdlFile = Boolean(
    prescriptionDrugListFile || prescriptionDrugListUrl
  );

  const additionalInfo = prescriptionDrugList || '';

  const dispatch = useAppDispatch();
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    try {
      setIsDownloading(true);
      await (dispatch(downloadPDLFile(carrier)) as any);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Modal
      maskClosable={false}
      width={820}
      visible={visible}
      footer={null}
      centered
      className={styles.prescriptionDrugListWrapper}
      onCancel={onCancel}
      closeIcon={<img src={closeIcon} alt="close-icon" />}
    >
      <div className={styles.providerHeader}>Prescription Drug List</div>
      <div className={styles.logoWrapper}>
        <img src={logoUrl} alt="carrier" className={styles.logo} />
      </div>
      <div className={styles.instructionWrapper}>
        <div className={styles.searchHeader}>Prescription Drug List Lookup</div>
        <div className={styles.urlWrapper}>
          <div>
            You can search for prescriptions in the Prescription Drug List
            document available below.
          </div>
        </div>
      </div>
      <div className={styles.additionalInfo}>
        {additionalInfo && (
          <div className={styles.additionalInfo}>
            <div className={styles.searchHeader}>Additional Information</div>
            <ul className={styles.instructionList}>{additionalInfo}</ul>
          </div>
        )}

        {hasPdlFile && (
          <div className={styles.buttonWrapper}>
            <SubmitButton
              className={styles.searchButton}
              onClick={handleDownload}
              type="primary"
              loading={isDownloading}
              disabled={isDownloading}
            >
              Download Prescription Drug List
            </SubmitButton>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default PrescriptionDrugListModal;
